import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e0ffd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "jobWrapper" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Templates:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Linked Jobs:", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]

import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import JobList from '@/components/JobList.vue'; // Import JobList component
import { useJobStore } from '@/stores/Jobs';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobTemplate',
  setup(__props) {

const jobStore = useJobStore();
const { isLoadingJobs } = storeToRefs(jobStore);
const route = useRoute();
const jobTemplateId = ref(parseInt(route.params.id as string));

const jobTemplate = computed(() => {
  return jobStore.getJobTemplates.find(template => template.id === jobTemplateId.value);
});

const linkedJobs = computed(() => {
  return jobStore.all_jobs.filter(job => job.job_template === jobTemplateId.value);
});

computed(() => {
  const allJobs = jobStore.all_jobs;
  console.log("Jobs in JobTemplate from store (JobTemplate.vue):", allJobs);
  return allJobs;
});

const computedJobs = computed(() => jobStore.all_jobs);

onMounted(async () => {
  console.log("Component mounted. Starting data fetch...");
  jobStore.getAllJobTemplates();
  jobStore.getAllJobs();
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (jobTemplate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(jobTemplate.value.name), 1),
            _createElementVNode("p", null, _toDisplayString(jobTemplate.value.description), 1),
            _hoisted_4,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobTemplate.value.task_templates, (taskTemplate) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: taskTemplate.id
                }, [
                  _createElementVNode("h3", null, _toDisplayString(taskTemplate.name), 1),
                  _createElementVNode("p", null, _toDisplayString(taskTemplate.description), 1)
                ]))
              }), 128))
            ]),
            _hoisted_5,
            (_unref(isLoadingJobs))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading Jobs..."))
              : (_openBlock(), _createBlock(JobList, {
                  key: 1,
                  jobs: computedJobs.value
                }, null, 8, ["jobs"])),
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: { name: 'createJob', params: { templateId: jobTemplate.value.id.toString() } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Job from Template")
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("a", {
                href: '/admin/ops/jobtemplate/' + jobTemplate.value.id.toString() + '/change/'
              }, "Edit Job Template", 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})